import RouterGuard from './_RouterGuards'
import store from '../store'
import ExternalMediaAssigner from '../components/socialMedia/ExternalMediaAssigner'
import WordpressLinker from '../components/marcomm/wordpressLinker/WordpressLinker'

export default {
  externalMediaAssigner: {
    path: '/communications/external-media-assigner',
    name: 'External Media Assigner',
    component: ExternalMediaAssigner,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  },
  wordpressTagAssigner: {
    path: '/communications/wordpress-tag-assigner',
    name: 'WordPressTagList',
    component: WordpressLinker,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasAdministrator)
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/communications.js